<!-- src/components/Sidebar.svelte -->
<script>
  import { createEventDispatcher } from 'svelte'
  import { agentStore } from '$lib/stores'

  const dispatch = createEventDispatcher()

  export let groups = []

  $: groupList = $agentStore.groups.length ? $agentStore.groups : [
    { id: 'hemp', name: 'hemp', icon: '🌿', color: '#4ade80' },
    { id: 'realestate', name: 'realestate', icon: '🏢', color: '#60a5fa' },
    { id: 'ai', name: 'ai', icon: '🤖', color: '#a78bfa' },
    { id: 'finance', name: 'finance', icon: '💰', color: '#fbbf24' },
    { id: 'recycling', name: 'recycling', icon: '♻️', color: '#34d399' },
    { id: 'research', name: 'research', icon: '🔬', color: '#f472b6' },
  ]

  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '◈' },
    { id: 'chat', label: 'Chat', icon: '💬' },
    { id: 'agents', label: 'Agent Runs', icon: '⚡' },
    { id: 'leads', label: 'Leads', icon: '◎' },
    { id: 'settings', label: 'Settings', icon: '⚙' },
  ]

  let activeNav = 'dashboard'

  function navigate(view) {
    activeNav = view
    dispatch('navigate', view)
  }
</script>

<aside class="sidebar glass">
  <div class="sidebar-header">
    <div class="logo">
      <span class="logo-icon metal-chrome">◈</span>
      <span class="logo-text metal-gold">GREA</span>
    </div>
  </div>

  <nav class="sidebar-nav">
    {#each navItems as item}
      <button
        class="nav-item"
        class:active={activeNav === item.id}
        on:click={() => navigate(item.id)}
      >
        <span class="nav-icon">{item.icon}</span>
        <span class="nav-label">{item.label}</span>
      </button>
    {/each}
  </nav>

  <div class="sidebar-groups">
    <div class="groups-header">GROUPS</div>
    {#each groupList as group}
      <div class="group-item" style="--group-color: {group.color}">
        <span class="group-icon">{group.icon}</span>
        <span class="group-name">{group.name}</span>
      </div>
    {/each}
  </div>

  <div class="sidebar-footer">
    <div class="status-pill">
      <span class="status-dot active"></span>
      <span>OmniRouter</span>
    </div>
  </div>
</aside>

<style>
  .sidebar {
    width: 240px;
    min-width: 240px;
    display: flex;
    flex-direction: column;
    padding: 20px 12px;
    border-radius: 0;
    border-left: none;
    border-top: none;
    border-bottom: none;
    background: var(--bg-panel);
    backdrop-filter: var(--blur-xl);
    -webkit-backdrop-filter: var(--blur-xl);
    z-index: 10;
  }

  .sidebar-header {
    padding: 0 8px 20px;
    border-bottom: 1px solid var(--glass-border);
    margin-bottom: 16px;
  }

  .logo {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .logo-icon {
    font-size: 28px;
    font-weight: 700;
  }

  .logo-text {
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 2px;
  }

  .sidebar-nav {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 24px;
  }

  .nav-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    border: none;
    background: transparent;
    color: var(--text-secondary);
    border-radius: var(--radius-md);
    cursor: pointer;
    transition: all var(--transition-fast);
    font-size: 14px;
    font-weight: 500;
  }

  .nav-item:hover {
    background: var(--glass-bg);
    color: var(--text-primary);
  }

  .nav-item.active {
    background: rgba(124, 92, 255, 0.15);
    color: var(--accent-primary);
  }

  .nav-icon {
    font-size: 18px;
    width: 24px;
    text-align: center;
  }

  .sidebar-groups {
    flex: 1;
    overflow-y: auto;
  }

  .groups-header {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1.5px;
    color: var(--text-muted);
    padding: 0 8px 8px;
  }

  .group-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    border-radius: var(--radius-sm);
    cursor: pointer;
    transition: all var(--transition-fast);
    font-size: 13px;
    color: var(--text-secondary);
  }

  .group-item:hover {
    background: var(--glass-bg);
    color: var(--text-primary);
    border-left: 2px solid var(--group-color);
  }

  .group-icon {
    font-size: 16px;
  }

  .sidebar-footer {
    padding-top: 16px;
    border-top: 1px solid var(--glass-border);
  }

  .status-pill {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: rgba(74, 222, 128, 0.1);
    border-radius: var(--radius-sm);
    font-size: 12px;
    color: #4ade80;
  }

  @media (max-width: 768px) {
    .sidebar {
      width: 60px;
      min-width: 60px;
      padding: 12px 8px;
    }
    .logo-text, .nav-label, .group-name, .groups-header, .sidebar-footer span:last-child {
      display: none;
    }
    .nav-item {
      justify-content: center;
      padding: 10px;
    }
  }
</style>